import React from 'react'

// reactstrap components
import { Container, Row, Col } from 'reactstrap'
// core components
function SectionDownload() {
  return (
    <>
      <div className="section text-center" id="como_funciona">
        <Container>
          <Row>
            <Col className="ml-auto mr-auto" md="8">
              <h2 className="title" style={{ fontWeight: 600, letterSpacing: 1, marginTop: 0 }}>
                Como Funciona
              </h2>
            </Col>
          </Row>
          <br />
          <br />
          <Row>
            <Col md="3">
              <div className="info">
                <div className="icon icon-info">
                  <i className="nc-icon nc-circle-10" style={{ color: '#F5593D' }} />
                </div>
                <div className="description">
                  <h4 className="info-title" style={{ fontWeight: 600, letterSpacing: 2 }}>
                    Pesquisa <br />
                    individual
                  </h4>
                  <p
                    className="description"
                    style={{
                      paddingTop: 10,
                      fontWeight: 400,
                      letterSpacing: 2,
                      fontSize: 14,
                      lineHeight: 1.6,
                    }}
                  >
                    Consulte a aprovação de cada estudante, de maneira individual.
                  </p>
                </div>
              </div>
            </Col>
            <Col md="3">
              <div className="info">
                <div className="icon icon-info">
                  <i className="nc-icon nc-zoom-split" style={{ color: '#F5593D' }} />
                </div>
                <div className="description">
                  <h4 className="info-title" style={{ fontWeight: 600, letterSpacing: 2 }}>
                    Pesquisa <br />
                    em massa
                  </h4>
                  <p
                    className="description"
                    style={{
                      paddingTop: 10,
                      fontWeight: 400,
                      letterSpacing: 2,
                      fontSize: 14,
                      lineHeight: 1.6,
                    }}
                  >
                    Consulte todas as aprovações dos seus estudantes de uma só vez.
                  </p>
                </div>
              </div>
            </Col>
            <Col md="3">
              <div className="info">
                <div className="icon icon-info">
                  <i className="nc-icon nc-paper" style={{ color: '#F5593D' }} />
                </div>
                <div className="description">
                  <h4 className="info-title" style={{ fontWeight: 600, letterSpacing: 2 }}>
                    Lista de <br />
                    aprovados
                  </h4>
                  <p
                    className="description"
                    style={{
                      paddingTop: 10,
                      fontWeight: 400,
                      letterSpacing: 2,
                      fontSize: 14,
                      lineHeight: 1.6,
                    }}
                  >
                    Acesse a lista com os resultados de todos os seus estudantes consultados.
                  </p>
                </div>
              </div>
            </Col>
            <Col md="3">
              <div className="info">
                <div className="icon icon-info">
                  <i className="nc-icon nc-chart-bar-32" style={{ color: '#F5593D' }} />
                </div>
                <div className="description">
                  <h4 className="info-title" style={{ fontWeight: 600, letterSpacing: 2 }}>
                    Resultados <br />
                    consolidados
                  </h4>
                  <p
                    className="description"
                    style={{
                      paddingTop: 10,
                      fontWeight: 400,
                      letterSpacing: 1.5,
                      fontSize: 14,
                      lineHeight: 1.6,
                    }}
                  >
                    Acesse os resultados de seus aprovados por instituição de ensino, curso e posição.
                  </p>
                </div>
              </div>
            </Col>
          </Row>
        </Container>
      </div>

      <div className="section" id="quem_somos"
      >
        <hr style={{ borderColor: '#ccc', borderWidth: 1, marginTop: -60 }} />
        <Container className="text-center"  style={{
        backgroundImage: 'url(' + require('assets/img/logo_marca.png') + ')',
        backgroundPosition: 'center',
        backgroundPaggingTop: 100,
        backgroundRepeat: 'no-repeat',
        backgroundSize: '28%',

      }}>
        <Row>
            <Col className="ml-auto mr-auto text-center" md="12">
            <h2 className="title" style={{ fontWeight: 600, letterSpacing: 2, marginTop: 50 }}>
                Quem Somos
              </h2>
              </Col>
        </ Row>
          <Row>

            <Col className="ml-auto mr-auto text-center" md="12">

              <p className="description" style={{ fontWeight: 400, letterSpacing: 1, lineHeight: 1.6 }}>
              <strong>A Evolucional acredita que o uso de dados pode transformar a educação e o processo de aprendizagem.</strong><br /><br />

              Atuamos desde 2014 oferecendo simulados e avaliações para escolas em todo o Brasil. Geramos dados precisos sobre o conhecimento dos alunos, e ajudamos as instituições de ensino na transformação da gestão pedagógica.<br /><br />


              Com mais de 4 milhões de avaliações já aplicadas e mais de 4.500 instituições atendidas, a Evolucional se destaca pelo alto rigor pedagógico presente em suas soluções, pelo atendimento junto às escolas e pelo uso de dados precisos para uma gestão de resultados.
</p>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  )
}

export default SectionDownload
